import {svgIconWrapper} from '../svg-icon-wrapper';

import CheckedCircleRegular from './checked-circle-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <CheckedCircleRegular {...props} />;
}
SvgComponent.iconName = 'checkedCircleRegular';

export const CheckedCircleRegularIcon = svgIconWrapper(SvgComponent);
